import { map } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
} from '@mui/material';
import Radio from '@mui/material/Radio';

import styles from './VendorApplication.module.css';

export default function VendorMerchType(props) {
  const { value = '', disabled } = props;
  const [merchType, setMerchType] = useState(value);

  const onChange = (e, val) => {
    setMerchType(val);
    props.onChange({
      target: { name: e.target.name, value: val },
    });
  };

  return (
    <FormControl
      variant="standard"
      margin="dense"
      fullWidth
      component="fieldset"
      style={{ marginTop: '24px' }}
    >
      <FormLabel component="legend" className={styles.subHeader}>
        Direct, 3rd Party Vendor or Hybrid*
      </FormLabel>
      <div className={styles.checkBoxes}>
        <RadioGroup
          color="primary"
          value={merchType}
          onChange={onChange}
          name="merch_type"
        >
          {map(['Direct', '3rd Party', 'Hybrid'], (t) => (
            <FormControlLabel
              label={t}
              key={t}
              value={t}
              control={<Radio />}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </div>
    </FormControl>
  );
}

VendorMerchType.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
